import React from 'react';
import ReactDOM from 'react-dom/client';

import { AuthProvider } from "./context/authContext";
import { FavoritesProvider } from "./context/favoritesContext";

import './index.css';
import App from './app';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AuthProvider>
    <FavoritesProvider>
      <App />
    </FavoritesProvider>
  </AuthProvider>
);

